<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      min-width="350px"
      max-width="550px"
      max-height="800px"
      offset-y
      left
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn depressed v-bind="attrs" v-on="on">
          <v-icon>mdi-view-column</v-icon>
        </v-btn>
      </template>

      <v-card outlined class="d-flex flex-column" style="max-height: 800px">
        <v-card-title class="font-weight-medium sticky-header"
          ><span class="text-subtitle-1 font-weight-medium"
            >Spalten auswählen</span
          >
          <v-spacer></v-spacer>
          <v-btn
            text
            small
            color="primary"
            :disabled="defaultState"
            @click="reset()"
            >Zurücksetzen</v-btn
          >
        </v-card-title>
        <v-card-subtitle class="sticky-header">
          <v-text-field
            v-model="search"
            outlined
            dense
            label="Spalten durchsuchen"
            hide-details="auto"
            prepend-inner-icon="mdi-magnify"
            class="mt-2"
            clearable
          ></v-text-field>
        </v-card-subtitle>
        <v-divider></v-divider>
        <v-data-table
          v-model="selectionLocalBuffer"
          :headers="listHeaders"
          :items="headers"
          :search="search"
          group-by="group"
          show-select
          fixed-header
          height="calc(60vh - 56px)"
          item-key="value"
          dense
          checkbox-color="primary"
          mobile-breakpoint="0"
          disable-pagination
          disable-sort
          hide-default-footer
        >
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th :colspan="listHeaders.length + 1">
              <div class="my-1">
                <v-icon @click="toggle" class="mr-1"
                  >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                </v-icon>
                <span>
                  {{ stripPrefix(items[0].group) }}
                </span>
                <span class="grey--text ml-1">({{ items.length }})</span>

                <v-btn
                  x-small
                  depressed
                  outlined
                  @click="selectAllOfGroup(items)"
                  class="ml-2"
                  ><v-icon small left>mdi-checkbox-multiple-outline</v-icon>Alle
                </v-btn>
              </div>
            </th>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-card-actions class="sticky-footer">
          <v-spacer></v-spacer>
          <v-btn text small color="primary" @click="close()">Abbrechen</v-btn>
          <v-btn depressed color="primary" small @click="apply()">
            Anwenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<style scoped>
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: inherit;
}

.sticky-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: inherit;
}
</style>

<script>
export default {
  name: "table-column-selector-menu",
  props: {
    selection: {},

    headers: {
      type: Array,
      required: false,
      default: () => [
        {
          sortKey: 1,
          text: "",
          value: "title",
          align: "start",
          default: true,
        },
      ],
    },
  },
  model: {
    prop: "selection",
    event: "selectionChange",
  },
  computed: {
    selectionLocal: {
      get: function () {
        return this.selection;
      },
      set: function (value) {
        this.$emit("selectionChange", value);
      },
    },
    defaultHeaders() {
      return this.headers.filter((header) => header.default);
    },
    defaultState() {
      return (
        this.selectionLocalBuffer.length === this.defaultHeaders.length &&
        this.selectionLocalBuffer.every((item) => item.default)
      );
    },
  },
  data() {
    return {
      menu: false,
      search: "",
      selectionLocalBuffer: [],
      listHeaders: [
        {
          text: "Titel",
          value: "text",
          align: "start",
        },
      ],
    };
  },
  created() {
    this.selectionLocalBuffer = this.selectionLocal;
  },
  methods: {
    close() {
      this.menu = false;
    },
    apply() {
      this.selectionLocalBuffer.sort((a, b) =>
        a.sortKey > b.sortKey ? 1 : -1
      );
      this.selectionLocal = this.selectionLocalBuffer;
      this.menu = false;
    },
    stripPrefix(groupKey) {
      if (!groupKey) return "";
      const underscoreIndex = groupKey.indexOf("_");
      return underscoreIndex !== -1
        ? groupKey.substring(underscoreIndex + 1)
        : groupKey;
    },
    selectAllOfGroup(items) {
      // Get currently selected values
      const selectedValues = this.selectionLocalBuffer.map((h) => h.value);
      // Find items from this group that are not already selected
      const newItems = items.filter(
        (item) => !selectedValues.includes(item.value)
      );
      // Add them to the selection
      this.selectionLocalBuffer = [...this.selectionLocalBuffer, ...newItems];
    },
    reset() {
      this.selectionLocalBuffer = this.defaultHeaders;
      this.selectionLocal = this.defaultHeaders;
    },
  },
};
</script>
